import { YouTubeVid } from 'components/YouTube'
import React from 'react'
import styled, { css } from 'styled-components'
import { VideoListItem, VideoListItemProps } from './Video.list.item'

export const videoListStyles = css`
	padding: 0 ${props => props.theme.sizes.gutter.mobile.val};
`

const VideoListView = styled.div`
	${videoListStyles}
`

export type VideoListProps = {
	videos?: YouTubeVid[]
	onClickVid?: VideoListItemProps['onClick']
}
export const VideoList: React.FC<VideoListProps> = ({ videos, onClickVid }) => {
	return (
		<VideoListView>
			{videos?.length
				? videos.map(video => (
						<VideoListItem video={video} key={video.youTubeVidId} onClick={onClickVid} />
				  ))
				: 'No videos yet...'}
		</VideoListView>
	)
}
